import React, { useState, useEffect } from 'react';
import CustomTab from './CustomTab';
import { IComponentTab, IComponent } from '../../component';
import { alpha } from '../../utils/color';
import { PHOTO_COMPONENT_TYPES } from '../../utils/util';
import RootStore from "../../store/RootStore";
import { inject, observer } from "mobx-react";

const setCustom = function(props: IComponentTab) {
  const { mode = 'top', activeBg, activeOpacity, fontSize, isBold } = props;
  let customFontSize = 0;
  let customBold = false;
  let activeColor = '';
  if (mode === 'top') {
    customFontSize = fontSize || 16; // top默认值是16
    customBold = isBold || false;
  } else {
    activeColor = alpha(activeBg, (activeOpacity || 100) / 100);
  }
  return { customFontSize, customBold, activeColor };
};

const TAB_SCOPE_KEY = '__activeCustomTabScope';

const createScopedEvent = (eventName: string, scope: { cid: string; index: number }) => {
  const event = new Event(eventName) as any;
  event.cid = scope.cid;
  event.index = scope.index;
  event.tabCid = scope.cid;
  event.tabIndex = scope.index;
  return event;
};

const setActiveTabScope = (scope: { cid: string; index: number }) => {
  (window as any)[TAB_SCOPE_KEY] = {
    cid: String(scope.cid),
    index: Number(scope.index),
  };
};

// TODO: 需要将滑动事件隔离起来，不要在多个tab下触发

const AllForTab = (props: IComponentTab) => {
  const [activeIndex, setActiveIndex] = useState(0);
  const { list, fixed, cid, mode = 'top' } = props;
  const { customFontSize, customBold, activeColor } = setCustom(props);

  const resetTabScrollState = (index: number) => {
    const scope = { cid: String(cid || ''), index: Number(index || 0) };

    const container = document.querySelector('.decorate-container') as HTMLDivElement | null;
    if (container) {
      container.scrollTop = 0;
      container.scrollLeft = 0;
    }
    window.scrollTo(0, 0);
    window.dispatchEvent(createScopedEvent('set-is-end-false', scope));
    window.dispatchEvent(createScopedEvent('tab-scroll-reset', scope));
  };

  const changeActiveIndex = (index: number) => {
    setActiveIndex(index);
    setActiveTabScope({ cid: String(cid || ''), index });
    resetTabScrollState(index);

    window.sessionStorage.setItem(`tab_${cid}`, `${index}`);

    let event = new Event('tab-index-change');
    event.data = index;
    event.cid = cid;

    window.dispatchEvent(event);
    setTimeout(() => {
      window.dispatchEvent(new Event(`custom-tab-height-change`));
      window.dispatchEvent(new Event(`resize`));
    }, 16);
  };

  const showPhotoPendant = () => {
    setTimeout(() => {
      let event = new Event('PENDENT_CHANGE');
      event.action = 'tab_has_photo';
      window.dispatchEvent(event);
    }, 320);
  };

  const hidePhotoPendant = () => {
    setTimeout(() => {
      let event = new Event('PENDENT_CHANGE');
      event.action = 'tab_no_photo';
      window.dispatchEvent(event);
    }, 320);
  };

  const checkPhoto = (index: number) => {
    if (list && list.length && list[index]) {
      let children = list[index]!.children as IComponent[];
      let exist = (children || []).find((it: IComponent) => {
        if (it && PHOTO_COMPONENT_TYPES.includes(it.type)) {
          return true;
        }
        return false;
      });

      if (exist) {
        showPhotoPendant();
        // 有照片的情况下，没有触发lazyload的加载
        let scrollY = window.scrollY;
        window.scrollTo(0, scrollY + 1);
        window.scrollTo(0, scrollY);
        // window.dispatchEvent(new Event('scroll'));
      } else {
        hidePhotoPendant();
      }
    }
  };

  const showCommentEvent = () => {
    setTimeout(() => {
      let event = new Event('custom-tab-has-comment');
      window.dispatchEvent(event);
    }, 16);
  };

  const hideCommentEvent = () => {
    setTimeout(() => {
      let event = new Event('custom-tab-no-comment');
      window.dispatchEvent(event);
    }, 16);
  };

  const checkComment = (index: number) => {
    if (list && list.length && list[index]) {
      let children = list[index]!.children as IComponent[];
      let exist = (children || []).find((it: IComponent) => {
        // @ts-ignore
        if (it && it.type == 'commentlist' && it.theme == 'list') {
          return true;
        }
        return false;
      });

      if (exist) {
        showCommentEvent();
      } else {
        hideCommentEvent();
      }
    }
  };

  const {pagedataStore} = props.rootStore!;
  useEffect(() => {
    let tab = document.getElementById(`tab_${cid}`);
    if (tab) {
      let tabs = tab.querySelector('.tabs');

      if (tabs && tabs.scrollWidth > tabs.clientWidth) {
        let active = tabs.querySelector('.active');
        if (active) {
          // @ts-ignore
          let offsetLeft = active.offsetLeft;
          tabs.scrollLeft = Math.max(
            0,
            offsetLeft - tabs.clientWidth / 2 + active.clientWidth / 2
          );
        }
      }
    }
    // 此处主要是要检测那些具备无限加载功能的组件，要让他们自己去控制自己的滑动逻辑
    checkPhoto(activeIndex);
    if(pagedataStore.renderMode != 'pc') {
      checkComment(activeIndex);
    }
  }, [activeIndex, pagedataStore.renderMode]);

  // 检测一下是否有最后一次的tab记录
  useEffect(()=>{
    let record = window.sessionStorage.getItem(`tab_${cid}`);
    if(record && record.length) {
      let index = Number(record);
      if(list && index < list.length) {
        console.log(`重新设置tab index`, `tab_${cid}`, index);
        changeActiveIndex(index);
      }
    } else {
      setActiveTabScope({ cid: String(cid || ''), index: activeIndex });
    }
  }, []);

  useEffect(() => {
    setActiveTabScope({ cid: String(cid || ''), index: activeIndex });
  }, [cid, activeIndex]);

  // 添加一个全局事件，主要是让自定义代码可以切换tab内容
  useEffect(() => {
    const customTabIndex = (e: any) => {
      if (e) {
        let { data } = e;
        if (typeof data !== 'undefined' && data !== null) {
          changeActiveIndex(Number(data));
        }
      }
    };
    window.addEventListener('custom-tab-index', customTabIndex);

    return () => {
      window.removeEventListener('custom-tab-index', customTabIndex);
    };
  }, []);

  return (
    <div id={`tab_${cid}`}>
      <CustomTab
        cid={cid}
        fixed={fixed}
        tabs={list}
        mode={mode}
        activeIndex={activeIndex}
        onClick={(index: number) => changeActiveIndex(index)}
        activeColor={activeColor}
        fontSize={customFontSize}
        isBold={customBold}
      />
    </div>
  );
};

export default inject("rootStore")(observer(AllForTab));
